import { Either } from 'src/utils/either';
import { endpoints } from 'src/utils/axios';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
} from '../../http';

export class FileRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  private async uploadFile(
    url: string,
    body?: any,
    fileName?: string | null
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url,
      body: {
        base64: body,
        name: fileName || new Date().getTime().toString(),
        ...(url === endpoints.files.upload ? { optimizateImage: true } : {}),
      },
    };
    const response = await this.api.request(request);
    return httpResponseHandler(response);
  }

  async upload(
    body?: any
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    return this.uploadFile(endpoints.files.upload, body);
  }

  async uploadLegacy(
    body?: any,
    fileName?: string | null
  ): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    return this.uploadFile(endpoints.files.uploadLegacy, body, fileName);
  }
}
